import styled from 'styled-components';

export const AppContainer = styled.div`
  width: 100%;
  height: 100%;
  font-family: Segoe, "Segoe UI", Arial, Helvetica, sans-serif;
`;
